// Ловушка для роботов и автозаполнение браузера.
//
// Поле-ловушка спрятано за краем экрана: человек его не видит, робот заполняет всё подряд, и
// сервер такую заявку молча отбрасывает (ApiSendAction, form_guard.trap_field). Но спрятанное
// поле видит автозаполнение: 20.10.2026 на avtofin.org Яндекс Браузер вместе с именем и
// телефоном вписал и `company_site`. Человек нажал «Отправить», увидел «Заявка отправлена»,
// а заявка не дошла никуда. `autocomplete="off"` автозаполнение не останавливает.
//
// Отличить браузер от робота можно по состоянию поля: заполненное автозаполнением браузер
// помечает `:autofill` (раньше `:-webkit-autofill`), и эта отметка есть только у значений,
// которые вписал сам браузер. Робот, который ставит value скриптом или набирает текст, её не
// получает и по-прежнему попадает в ловушку. Робот без JS до сюда не доходит вовсе: токен
// формы выдаётся только скриптом.
//
// Значение, вписанное автозаполнением, просто не уходит на сервер. Новых полей в заявке нет:
// сервер, каналы заказчика и письма ничего не меняют.

export const TRAP_SELECTOR = '.form-callback__trap input[name]';

const AUTOFILL_STATES = [':autofill', ':-webkit-autofill'];

/** Поле заполнил браузер. Незнакомый браузеру селектор бросает исключение — это «нет». */
export function isAutofilled(input) {
  for (const state of AUTOFILL_STATES) {
    try {
      if (input.matches(state)) return true;
    } catch {
      // селектор не поддерживается — пробуем следующий
    }
  }
  return false;
}

/**
 * Убирает из отправки ловушки, которые заполнил браузер. Возвращает их имена — для отчёта
 * маячка; ловушки, заполненные не браузером, остаются как есть.
 */
export function dropAutofilledTraps(form, formData) {
  const dropped = [];
  form.querySelectorAll(TRAP_SELECTOR).forEach((input) => {
    if (!input.value || !isAutofilled(input)) return;
    formData.delete(input.name);
    dropped.push(input.name);
  });
  return dropped;
}
